import React from 'lib/react';
import {
  EVGrid,
} from 'lib/components';
import Typography from 'commonComponents/typography';
import { useSelector } from 'lib/redux';
import { CLAIM_INFO_FIELDS } from '../OrderHistory.constants';
import { getHighlightedText } from '../OrderHistory.utils';

function ExpandedClaimInfoSection({ expandedRowData }) {
  const { searchText } = useSelector(({ orderHistory }) => ({ searchText: orderHistory.searchText }));
  return (
    // #genai - Claim field names are stable identities.
    Object.keys(expandedRowData)
      .filter((key) => expandedRowData[key])
      .map((key) => (
        <EVGrid key={key} style={{ minWidth: '120px' }}>
          <Typography variant="label-600" style={{ textTransform: 'uppercase' }}>{CLAIM_INFO_FIELDS[key]}</Typography>
          <Typography variant="subtitle-400" fontColor="charcoal-700">{getHighlightedText(expandedRowData[key], searchText)}</Typography>
        </EVGrid>
      ))
  );
}

export default ExpandedClaimInfoSection;
